import { LevelGranulometry } from '../../domain/granulometry/levels/LevelGranulometry';

export const isThisLevelSectionWrapped = (level: LevelGranulometry): boolean => {
  return !!(level.sectionWrapper && level.sectionWrapper.theoricalWidth);
};
